import clsx from "clsx";
import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { transformViewDate } from "utils/date-utils";

import { getTypeLabel } from "./helper";
import useStyles from "./styles";

export interface IProps {
  notification: racehorse360.INotification;
  index: number;
  onClickNotification: () => void;
}

const DashboardNotificationItem = (props: IProps) => {
  const { notification, index, onClickNotification } = props;
  const classes = useStyles();
  const isUnread = !notification?.isRead;
  const dataTestIndicatorValue = isUnread
    ? "unreadDotIndicator"
    : "readDotIndicator";

  return (
    <div
      role="button"
      tabIndex={0}
      className={clsx(classes.itemRoot, {
        [classes.itemRootOdd]: !(index % 2),
        [classes.unread]: isUnread
      })}
      onClick={onClickNotification}
    >
      <div className={classes.marker} data-test-id={dataTestIndicatorValue} />
      <div className={classes.rowsWrapper}>
        <div className={classes.rowHeader}>
          <span
            className={clsx(classes.notificationType, {
              [classes.unread]: isUnread
            })}
            data-test-id={"notificationsListElement"}
          >
            {`${getTypeLabel(notification?.type)} - ${transformViewDate(
              notification?.updatedOn,
              null,
              "MM/dd/yy"
            )}`}
          </span>
        </div>
        <div className={classes.rowContent}>
          {notification?.horse?.name || "No Name"}
        </div>
      </div>
    </div>
  );
};

export default DashboardNotificationItem;
